import { IAppointment } from '../../../../API/GoMoto';
import { isElectron } from '../../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { LicenseScanKioskIndex } from './LicenseScanKioskIndex';

export interface ILicenseScanIndexProps {
    onManualEntry: (skip?: boolean) => void;
    onProceed: () => void;
}

export interface ICaptureResults extends Pick<IAppointment, 'firstName' | 'lastName' | 'street' | 'city' | 'stateOrProvince' | 'postalCode'> { }

export const LicenseScanIndex = (props: ILicenseScanIndexProps) => (isElectron() ? <LicenseScanKioskIndex {...props} /> : <></>);
